// extracted by mini-css-extract-plugin
export default {"viewer":"PdfViewer_viewer__WqUJ7","fullHeight":"PdfViewer_fullHeight__LMxoz"};